import { useMutation, useQueryClient } from '@tanstack/react-query';
import { activateLicense } from '../services/license.api';
import { licenseKeys } from './use-license-status';

/**
 * Activate/renew the license with a signed key. On success refreshes the
 * cached status so the LicenseGuard and any status displays react immediately.
 */
export function useActivateLicense() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (key: string) => activateLicense(key),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: licenseKeys.status });
    }
  });
}
